import { render } from "./ShowcaseOzzaym.vue?vue&type=template&id=79fed073"
import script from "./ShowcaseOzzaym.vue?vue&type=script&lang=js"
export * from "./ShowcaseOzzaym.vue?vue&type=script&lang=js"

import "./ShowcaseOzzaym.vue?vue&type=style&index=0&id=79fed073&lang=css"
import "./ShowcaseOzzaym.vue?vue&type=style&index=1&id=79fed073&lang=css"

import exportComponent from "/home/runner/work/leadsbroker-showcase/leadsbroker-showcase/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__